import React, { useState, useEffect } from "react";
import "./textInputStyle.scss";

const TextInputSecondary = ({ 
  label, 
  type = "text",  
  name, 
  value, 
  onChange, 
  placeholder, 
  required = false,
  isFieldChecked = false,
  requiredMsg = '',
  handleSecondaryCheck,
  secondaryCheckText = '',
  isSecondaryCheck = false,
  disabled = false,
  flag = '',
  flagSrc = "",
  flagAlt = "Flag",
  prefixText = "",
  prefixWidth = 45,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isTouched, setIsTouched] = useState(false);   
  const [isValid, setIsValid] = useState(true);  
  const [isChecked, setIsChecked] = useState(isFieldChecked);  // NEW STATE
  const [isSecondChecked, setIsSecondChecked] = useState(false)

  useEffect(() => {
    setIsChecked(isFieldChecked);
  }, [isFieldChecked]);

  useEffect(() => {
    if (value) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [value]);

  const handleBlur = () => {
    setIsTouched(true);
    validateInput(value);  
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailPattern.test(email);
  };

  const validateMobile = (mobile) => {
    const mobilePattern = /^[0-9]{10}$/;  
    return mobilePattern.test(mobile);
  };

  const validateInput = (inputValue) => {
    if (type === "email") {
      setIsValid(validateEmail(inputValue));
    } else if (type === "tel" || name.toLowerCase().includes("mobile")) {
      setIsValid(validateMobile(inputValue));
    }
  };

  const isError = (required && isTouched && !value) || (!isValid && isTouched);

  const handleCheckboxChange = () => {
    const nextChecked = !isChecked;
    setIsChecked(nextChecked);

    if (typeof handleSecondaryCheck === "function") {
      // If no secondary checkbox is enabled, propagate the primary checkbox state.
      if (!isSecondaryCheck) {
        handleSecondaryCheck(nextChecked);
      } else if (!nextChecked) {
        // Reset secondary state when primary checkbox is turned off.
        setIsSecondChecked(false);
        handleSecondaryCheck(false);
      }
    }
  };

  const handleSecondCheckboxChange = () => {
    const nextSecondChecked = !isSecondChecked;
    setIsSecondChecked(nextSecondChecked);
    if (typeof handleSecondaryCheck === "function") {
      handleSecondaryCheck(nextSecondChecked);
    }
  };

  return (
    <div className={`SecInput form-group text-input ${isActive ? 'active' : ''}`}>
      <label htmlFor={name} className="form-label checkbox-label">
        <input
          className="form-check-input input-checkbox rounded-4"
          checked={isChecked}
          onChange={handleCheckboxChange}
          type="checkbox"
          id="flexCheckDefault"
        />
        <span className="label-text fw-semibold">
          {label} {required && <span className="required">*</span>}
        </span>

        {(isSecondaryCheck && isChecked) && <span className="secondary-check-text">
          <span className="second-checkbox-wrapper">
            <input
              className="form-check-input input-checkbox rounded-4"
              checked={isSecondChecked}
              onChange={handleSecondCheckboxChange}
              type="checkbox"
            />
          </span>
          {secondaryCheckText}</span>}
      </label>

      <div className="input-wrapper" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {(flag || flagSrc || prefixText) && (
          <span className="input-prefix">
            {flagSrc && (
              <img
                src={flagSrc}
                alt={flagAlt}
                className="input-prefix-flag"
              />
            )}
            {flag && <span className="input-prefix-emoji">{flag}</span>}
            {prefixText && <span className="input-prefix-text">{prefixText}</span>}
          </span>
        )}
        <input
          type={type}
          className={`form-control ${isError ? 'error' : ''}`}
          id={name}
          name={name}
          value={isChecked ? value : ""}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          onFocus={() => setIsActive(true)}
          onBlur={() => {
            setIsActive(false);
            handleBlur();
          }}
          disabled={!isChecked || disabled} // disables until checkbox checked
          style={{
            paddingLeft: (flag || flagSrc || prefixText) ? `${prefixWidth}px` : '10px'
          }}
        /> 
      </div>

      {isError && (
        <small className="error-text">
          {!value
            ? requiredMsg ? requiredMsg : '' : ''}
        </small>
      )}
    </div>
  );
};

export default TextInputSecondary;
